import { useGetMasterProvice } from "hooks/useMasterData";
import styled from "@emotion/styled";
import { Button, Cascader, DatePicker, Form, FormInstance, Input, Row, Select, Spin, Typography } from "antd";
import dayjs from "dayjs";
import { FC, useEffect, useState } from "react";
import { MasterProvinceData } from "services/interface";
import { useGetDcAllList } from "hooks/useDc";
 
const { Option } = Select;

interface SearchLotDetailFormProps {
  form: FormInstance;
}

const SearchLotDetailForm: FC<SearchLotDetailFormProps> = ({form}) => {
    const [province, setProvince] = useState<MasterProvinceData[]>([]);
    const [provinceId, setProvinceId] = useState<number>(0)
    const { data: masterProviceData, isLoading: proviceLoading } = useGetMasterProvice();
    const { data: dcData, isLoading: dcLoading } = useGetDcAllList({
        province_id: provinceId
    });
    const [childrenDc, setChildrenDc] = useState<React.ReactNode[]>([]);


    useEffect(() => {
        if (masterProviceData) {
        setProvince(masterProviceData);
        }
    }, [masterProviceData]);

  useEffect(() => {
    setChildrenDc(() => {
      let updatedChildrenDc: React.ReactNode[] = [];
      if (dcData?.data?.dc_data) {
        updatedChildrenDc = dcData.data.dc_data.map((item) => (
          <Option key={item.id} value={item.id}>
            {item.name}
          </Option>
        ));
      }
      return updatedChildrenDc;
    });
  }, [dcData, provinceId]);

  
    const childrenProvince: React.ReactNode[] = [];
    if (province && province.length > 0) {
        childrenProvince.push(
          <Option key='' value=''>ทั้งหมด</Option>
        );
    }

    province?.map((item) => {
        childrenProvince.push(
        <Option key={item.id} value={item.id}>
            {item.name_th}
        </Option>
        );
    });
  
  return (
    <>
  <div style={{ flex: '1 1 70%', display: 'flex', flexWrap: 'wrap' }}>
      <div style={{ flex: '1 1 50%', padding: '8px' }}>
      <Form.Item name="search" style={{ marginBottom: 0 }} label="ค้นหาคำ" >
          <Input />
        </Form.Item>
      </div>
      <div style={{ flex: '1 1 50%', padding: '8px' }}></div>
 
      <div style={{ flex: '1 1 50%', padding: '8px' }}>
        <Form.Item
            style={{margin:0}}
            label="จังหวัด"
            name="province_id"
            rules={[{ required: false, message: "กรุณาเลือกจังหวัด" }]}
          >
            <Select
              // showSearch
              placeholder="เลือกจังหวัด"
              optionFilterProp="children"
              notFoundContent={proviceLoading ? <Spin size="small" /> : null}
              loading={proviceLoading}
              onChange={(value) => {
                form.setFieldsValue({
                  dc_id: null,
                })
                setProvinceId(value);
              }}
            >
              {childrenProvince}
            </Select>
          </Form.Item>
      </div>

      <div style={{ flex: '1 1 50%', padding: '8px' }}>
        <Form.Item
            style={{margin:0}}
            label="ศูนย์กระจายสินค้า"
            name="dc_id"
            rules={[{ required: false, message: "กรุณาเลือ  กศูนย์กระจายสิค้า" }]}
          >
            <Select
              placeholder="เลือกศูนย์กระจายสินค้า"
              optionFilterProp="children"
              notFoundContent={dcLoading ? <Spin size="small" /> : null}
              loading={dcLoading}
              >
             {childrenDc} 
            </Select>
          </Form.Item>
      </div>
    </div>
    </>
  );
};

export default SearchLotDetailForm;